import React from 'react'
import { css } from '@emotion/core'
import { Skeleton, useContainerWidth } from '@fs/zion-ui'

const Horizontal = () => {
  const atWidth = useContainerWidth()

  return (
    <div>
      <Skeleton.Image
        height={atWidth({
          default: 400,
          sm: 400,
          md: 450,
          lg: 500,
        })}
      />
    </div>
  )
}

const backgroundCss = css`
  background-color: #01496e;
`

const Vertical = () => {
  const atWidth = useContainerWidth()
  return (
    <div css={backgroundCss}>
      <Skeleton.Image
        height={atWidth({
          default: 400,
          sm: 400,
          md: 450,
          lg: 550,
        })}
      />
      <Skeleton.H1 />
    </div>
  )
}

export default function VolunteerBanerSkeleton() {
  const atWidth = useContainerWidth()
  const cSize = atWidth({
    default: 400,
    sm: 400,
    md: 450,
    lg: 550,
  })

  return (
    <div data-testid="VolunteerWhereYouAreSkeleton">
      {atWidth({
        default: <Vertical />,
        md: <Horizontal size={cSize} />,
        lg: <Horizontal size={cSize} />,
      })}
    </div>
  )
}
